    <div class="client-list">
      <div class="page-header">
        <h1 class="page-title">Клиенты</h1>
        <button mat-mini-fab color="primary" routerLink="/clients/new" aria-label="Добавить">
          <mat-icon>person_add</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Поиск</mat-label>
        <input matInput [(ngModel)]="searchQuery" (ngModelChange)="onSearch($event)"
               placeholder="Имя, фамилия или телефон">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div *ngIf="!loading && clients.length > 0" class="clients-list">
        <app-client-card *ngFor="let c of clients" [client]="c" />
      </div>

      <div *ngIf="!loading && clients.length === 0 && searchQuery.length >= 2" class="empty-state">
        <mat-icon>person_off</mat-icon>
        <p>Клиенты не найдены</p>
      </div>

      <div *ngIf="!loading && clients.length === 0 && searchQuery.length < 2" class="empty-state">
        <mat-icon>group</mat-icon>
        <p>Клиентов пока нет</p>
      </div>

      <app-pagination *ngIf="!loading && totalItems > 0"
        [page]="currentPage"
        [totalPages]="totalPages"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
